import FreeRounds from 'components/Icons/FreeRounds'
import Unfinished from 'components/Icons/Unfinished'
import styled, { keyframes } from 'styled-components'
import { brandSecondary, dangerBg, grayLighter } from 'utils/style-utils'

export const TitleBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.25rem;
`

export const Name = styled.span`
  flex: 1;
  display: block;
  padding: 0 0.25rem;
  margin-bottom: 0.25rem;
  text-align: center;
  color: ${grayLighter};
  font-size: 0.875rem;
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const GameStateBox = styled.div`
  display: flex;
  gap: 0.25rem;
`

const anim = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
`

export const FreeRoundsIcon = styled(FreeRounds)`
  fill: ${brandSecondary};
  width: 1.125rem;
  height: 1.125rem;

  & > #spin {
    animation: 3s ${anim} cubic-bezier(0.26, 1.43, 0.65, 1) forwards infinite;
    transform-origin: center;
  }
`

export const UnfinishedIcon = styled(Unfinished)`
  fill: ${dangerBg};
  width: 1.125rem;
  height: 1.125rem;
`
